export default __webpack_public_path__ + "locales/sr-Cyrl-RS/SalesDepartmentRequestDialog.json?hash=d7fc187712de209ad0e5a60934b5c43b";